
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.667 3l2.869 2.869a4.008 4.008 0 005.664 5.667l2.8 2.8L14.333 37l-2.8-2.8a4.007 4.007 0 10-5.667-5.667L3 25.667 25.667 3M21.2 13.785a1.5 1.5 0 10-1.062-.441 1.5 1.5 0 001.062.441m3.261 3.26a1.5 1.5 0 10-1.063-.44 1.495 1.495 0 001.063.44m3.261 3.262a1.5 1.5 0 10-1.062-.44 1.5 1.5 0 001.062.44M25.667.172l-1.414 1.414L1.586 24.253.172 25.667l1.414 1.414 2.869 2.869 1.413 1.414 1.415-1.414a2.007 2.007 0 112.839 2.838L8.707 34.2l1.415 1.415 2.8 2.8 1.415 1.414 1.414-1.414 22.663-22.668 1.414-1.414-1.414-1.414-2.8-2.8-1.409-1.411-1.415 1.414a2.007 2.007 0 11-2.839-2.838l1.414-1.415-1.414-1.414-2.869-2.869L25.667.172z"}})])
          )
        }
      }
    